const API_URL = import.meta.env.VITE_API_URL || '';

const EDITOR_APP_URL = import.meta.env.VITE_EDITOR_APP_URL || '';

// Extract host URL from editor URL (e.g., https://picsart.com from https://picsart.com/create/editor)
const PICSART_HOST_URL = EDITOR_APP_URL
  ? new URL(EDITOR_APP_URL).origin
  : 'https://picsart.com';

const LIBRARY_TABS_KEY = import.meta.env.VITE_LIBRARY_TABS_KEY || '';

const LIBRARY_BASE_URL = import.meta.env.VITE_LIBRARY_URL || '';

const LIBRARY_URL = `${LIBRARY_BASE_URL}/grids`;

const LIBRARY_TABS_URL = `${LIBRARY_BASE_URL}/hubs/${LIBRARY_TABS_KEY}/grids?landingType=flow`;

const LIBRARY_ITEM_URL = `${LIBRARY_BASE_URL}/landings`;

const FLOW_LANDINGS_URL = `${LIBRARY_BASE_URL}/flow-landings/slug`;

const MAGIC_FLOW_WEBHOOK_URL = `${API_URL}/workflows/magic-flow-webhook`;

const SUBMIT_WEB_HOOK_URL = `${MAGIC_FLOW_WEBHOOK_URL}/submit`;

const CREDIT_CALCULATOR_URL = `${API_URL}/workflows/magic-flow-webhook-calculator/execute`;

const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL || '';

const MOBILE_EDITOR_URL = 'picsart://apps';

export {
  API_URL,
  EDITOR_APP_URL,
  PICSART_HOST_URL,
  LIBRARY_TABS_KEY,
  LIBRARY_BASE_URL,
  LIBRARY_URL,
  LIBRARY_TABS_URL,
  LIBRARY_ITEM_URL,
  FLOW_LANDINGS_URL,
  MAGIC_FLOW_WEBHOOK_URL,
  SUBMIT_WEB_HOOK_URL,
  CREDIT_CALCULATOR_URL,
  UPLOAD_URL,
  MOBILE_EDITOR_URL,
};
